import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-798708ce"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "progress__container"
};
const _hoisted_2 = {
  class: "progress__step"
};
const _hoisted_3 = {
  class: "step__header"
};
const _hoisted_4 = ["onClick"];
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    progressData: {
      type: Array,
      default: []
    },
    modelValue: {
      type: Number,
      default: 0
    }
  },
  emits: ['on-step-click'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const activeIndex = computed(() => {
      return props.progressData.findIndex(f => f.key == props.modelValue) + 1;
    });

    const handleStepIconClick = index => {
      emit('on-step-click', index);
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.progressData, (line, index) => {
        return _openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
          class: _normalizeClass(['step__title', {
            'step__title--active': index < _unref(activeIndex)
          }])
        }, _toDisplayString(_ctx.$t(line.title)), 3), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
          class: _normalizeClass(['progress__line', {
            'progress__line--active': index < _unref(activeIndex)
          }]),
          style: _normalizeStyle({
            opacity: index === 0 ? 0 : 1
          })
        }, null, 6), _createElementVNode("div", {
          onClick: $event => handleStepIconClick(index),
          class: _normalizeClass(['step-icon', {
            'step--active': index === _unref(activeIndex) - 1,
            'step--finish': index < _unref(activeIndex) && index !== _unref(activeIndex) - 1
          }])
        }, _toDisplayString(index === _unref(activeIndex) - 1 ? '0' + (index + 1) : ''), 11, _hoisted_4), _createElementVNode("div", {
          class: _normalizeClass(['progress__line', {
            'progress__line--active': _unref(activeIndex) - 1 != index && index < _unref(activeIndex)
          }]),
          style: _normalizeStyle({
            opacity: index === __props.progressData.length - 1 ? 0 : 1
          })
        }, null, 6)])]);
      }), 256))]);
    };
  }

});